export const options = [
	{
		label: "Provide Ticketmaster email account login and password",
		value: "Provide Ticketmaster email account login and password",
	},
	{
		label: "Provide AM Ticketmaster email account login and password",
		value: "Provide AM Ticketmaster email account login and password",
	},
	{
		label: "Provide evenue account email login and password",
		value: "Provide evenue account email login and password",
	},
	{ label: "Provide evenue account number", value: "Provide evenue account number" },
	{ label: "Send over etickets for this listing", value: "Send over etickets for this listing" },
	{ label: "Tickets are not in the account, please research", value: "Tickets are not in the account, please research" },
	{
		label: "In-hand date is near, do you have these tickets in hand?",
		value: "In-hand date is near, do you have these tickets in hand?",
	},
	{ label: "Account password reset is needed", value: "Account password reset is needed" },
	{ label: "Other", value: "Other" },
];
